import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
export function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
}
export var sortGradient = function sortGradient(gradients) {
  var tempArr = [];
  _Object$keys(gradients).forEach(function (key) {
    var formattedKey = parseFloat(key.replace(/%/g, ''));
    if (!isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key]
      });
    }
  });
  tempArr = _sortInstanceProperty(tempArr).call(tempArr, function (a, b) {
    return a.key - b.key;
  });
  return _mapInstanceProperty(tempArr).call(tempArr, function (_ref) {
    var _context;
    var key = _ref.key,
      value = _ref.value;
    return _concatInstanceProperty(_context = "".concat(value, " ")).call(_context, key, "%");
  }).join(', ');
};
export var handleGradient = function handleGradient(strokeColor) {
  var _context3, _context4;
  var from = strokeColor.from,
    to = strokeColor.to,
    _strokeColor$directio = strokeColor.direction,
    direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
    rest = __rest(strokeColor, ["from", "to", "direction"]);
  if (_Object$keys(rest).length !== 0) {
    var _context2;
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: _concatInstanceProperty(_context2 = "linear-gradient(".concat(direction, ", ")).call(_context2, sortedGradients, ")")
    };
  }
  return {
    backgroundImage: _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "linear-gradient(".concat(direction, ", ")).call(_context4, from, ", ")).call(_context3, to, ")")
  };
};